// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__header-b1a9a0 {
  padding: 8px 12px 0;
  margin-bottom: 4px;
}

.Header__sender-name-cc9150 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.Header__sender-name-cc9150.Header__wide-gap-b61e7d {
  margin-bottom: 4px;
}
.Header__sender-name-cc9150.Header__dynamic-length-c3f110 {
  min-height: 18px;
  position: relative;
}
.Header__sender-name-cc9150.Header__dynamic-length-c3f110 > span {
  position: absolute;
  left: 0;
  right: 0;
}

.Header__forward-feb85f {
  min-width: 176px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/MediaBubble/Header/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,OAAA;EACA,QAAA;AAAN;;AAKA;EACE,gBAAA;AAFF","sourcesContent":[".header {\n  padding: 8px 12px 0;\n  margin-bottom: 4px;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n\n  &.wide-gap {\n    margin-bottom: 4px;\n  }\n\n  &.dynamic-length {\n    min-height: 18px;\n    position: relative;\n\n    & > span {\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n  }\n}\n\n.forward {\n  min-width: 176px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header__header-b1a9a0`,
	"sender-name": `Header__sender-name-cc9150`,
	"senderName": `Header__sender-name-cc9150`,
	"wide-gap": `Header__wide-gap-b61e7d`,
	"wideGap": `Header__wide-gap-b61e7d`,
	"dynamic-length": `Header__dynamic-length-c3f110`,
	"dynamicLength": `Header__dynamic-length-c3f110`,
	"forward": `Header__forward-feb85f`
};
module.exports = ___CSS_LOADER_EXPORT___;
